// extracted by mini-css-extract-plugin
export default {"header":"style_header__PdEJE","body":"style_body__2AuDJ","symbol":"style_symbol__cUB+3","message":"style_message__7C5c6","icon":"style_icon__IMYeb","dialog":"style_dialog__F4Axp"};